import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M39 25C39 32.732 32.732 39 25 39C17.268 39 11 32.732 11 25C11 17.268 17.268 11 25 11C32.732 11 39 17.268 39 25Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 25H30",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 20V30",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPlusCircleFilled);
export default ForwardRef;
